<template>
    <div>
        <b-form-group :label="component.properties.label" class="mb-0">
            <template v-if="component.type === 'text'">
                <el-input :value="modelValue" @input="$emit('input', $event)"
                    :placeholder="component.properties.placeholder" :maxlength="component.properties.maxlength"
                    size="small" show-word-limit />
            </template>

            <template v-else-if="component.type === 'textarea'">
                <el-input :value="modelValue" @input="$emit('input', $event)" type="textarea"
                    :placeholder="component.properties.placeholder" :rows="component.properties.rows"
                    :maxlength="component.properties.maxlength" size="small" show-word-limit />
            </template>

            <template v-else-if="component.type === 'select'">
                <el-select :value="modelValue" @input="$emit('input', $event)" size="small" filterable clearable
                    :placeholder="component.properties.placeholder" style="width: 100%">
                    <el-option v-for="option in component.properties.options" :key="option.id" :label="option.name"
                        :value="option.id" />
                </el-select>
            </template>

            <template v-else-if="component.type === 'multiselect'">
                <el-select :value="modelValue" @input="$emit('input', $event)" multiple size="small" filterable
                    clearable :placeholder="component.properties.placeholder" style="width: 100%">
                    <el-option v-for="option in component.properties.options" :key="option.id" :label="option.name"
                        :value="option.id" />
                </el-select>
            </template>

            <template v-else-if="component.type === 'checkbox'">
                <el-radio-group :value="modelValue" @input="$emit('input', $event)" size="small">
                    <el-radio-button :label="1">SI</el-radio-button>
                    <el-radio-button :label="0">NO</el-radio-button>
                </el-radio-group>
            </template>

            <template v-else-if="component.type === 'date'">
                <el-date-picker :value="modelValue" @input="$emit('input', $event)" size="small" type="date"
                    format="yyyy-MM-dd" value-format="yyyy-MM-dd" :placeholder="component.properties.placeholder"
                    style="width: 100%" />
            </template>

            <template v-else-if="component.type === 'number'">
                <div class="number-field-wrapper">
                    <el-input-number v-model="localValue" size="small" controls-position="right"
                        :min="component.properties.min" :max="component.properties.max" :step="1" style="width: 100%" />
                </div>
            </template>

            <template v-else-if="component.type === 'decimal'">
                <div class="number-field-wrapper">
                    <el-input-number v-model="localValue" size="small" controls-position="right"
                        :min="component.properties.min" :max="component.properties.max" :step="0.01" :precision="2"
                        style="width: 100%" />
                </div>
            </template>

            <div v-if="error" class="text-danger small mt-1">
                {{ error }}
            </div>
        </b-form-group>
    </div>
</template>

<script>
export default {
    name: "DynamicField",
    props: {
        component: {
            type: Object,
            required: true
        },
        modelValue: {
            type: [String, Number, Array, Boolean, Object],
            default: null
        },
        error: {
            type: String,
            default: null,
        },
    },
    computed: {
        localValue: {
            get() {
                if (this.component.type === 'number' || this.component.type === 'decimal') {
                    return this.modelValue === null || this.modelValue === undefined ? undefined : this.modelValue;
                }
                return this.modelValue;
            },
            set(value) {
                this.$emit('input', value === '' ? null : value);
            }
        }
    },
    methods: {
        handleNumberChange(value) {
            this.$emit('input', value);
        },
    }
}
</script>

<style scoped>
.dynamic-field {
    width: 100%;
}

.form-control-custom {
    width: 100% !important;
    display: block;
}

.form-control-custom.el-input-number {
    width: 100% !important;
}

.form-control-custom.el-input-number .el-input__inner {
    text-align: left;
    padding-left: 15px;
}

:deep(.el-input__wrapper),
:deep(.el-select),
:deep(.el-date-editor),
:deep(.el-input-number__decrease),
:deep(.el-input-number__increase) {
    box-shadow: none !important;
}

:deep(.el-input__wrapper),
:deep(.el-select .el-input__wrapper),
:deep(.el-date-editor.el-input__wrapper),
:deep(.el-input-number .el-input__wrapper) {
    padding: 1px 11px;
}
</style>
